var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapChackicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76745 9C3.54284 9 3.20592 8.8877 2.98131 8.66308L0.285975 5.51853C-0.163248 5.0693 -0.0509421 4.39547 0.398281 3.94625C0.847503 3.49702 1.52134 3.60933 1.97056 4.05855L3.87976 6.19236L9.04582 0.352464C9.49504 -0.0967582 10.1689 -0.0967582 10.6181 0.240159C11.0673 0.689381 11.0673 1.36322 10.7304 1.81244L4.6659 8.55078C4.44128 8.8877 4.10437 9 3.76745 9Z",
    fill: "#151625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapChackicon);
export default __webpack_public_path__ + "static/media/roadmapChackicon.9b7b9294314819ccc06c284950d348f4.svg";
export { ForwardRef as ReactComponent };